import React, { useEffect, useState, Fragment } from 'react';
import { withRouter, useHistory, useLocation } from 'react-router-dom';
import { connect } from "react-redux";
import MUIDataTable from "mui-datatables";
import * as logger from "../../../../logger";
import TapLayout from "../../../components/PageLayout/TabLayOut";
import { PassBookTabSupplierCss } from "../SupplierCss";
import { fetchSupplierTransactionLog } from "../../../../store/actions/userActionCreators";
import { numberFormat, getTripStartDateFilterValues, getDateInStringDDMMMYYYY, getRequestTimeInMillis, getDatePickerDateInStringDDMMMYYYY } from "../../../../utils/utils";
import {
    Grid,
    IconButton,
    InputAdornment,
    Button
} from "@material-ui/core";
import { TRIP_FILTER_STATUS_MAPPING, TRIP_STATUS_LABELS, TRIP_ACTIONS_SUPPLIER, TRIP_TRANSACTION_FILTER } from '../../../../store/constants';
import { getSingleVendorLedgerData } from '../../../../store/actions/homeActionCreator';
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';
import ReportsDialog from '../../../components/ReportsDialog/ReportsDialog';
import PictureAsPdfIcon from '@material-ui/icons/PictureAsPdf';
import { tripTableHeight, tableHeightWithSparkline, tableHeightWithSparklineSingle } from "../../../../styleVariables";
import DateFilter from '../../../components/FilterComponent/DateFilter';
import PaymentTabFilter from '../../../components/FilterComponent/PaymentTabFilter';
import SearchIcon from '@material-ui/icons/Search';
import InfoDialog from "../../../components/Dialog/InfoDialog";
import clsx from 'clsx';
import FiberManualRecordIcon from '@material-ui/icons/FiberManualRecord';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import PaymentDetailsSideBar from '../../../components/Supplier/PaymentDetailsSideBar';
import { PaperPlaneIconWhite } from '../../../../components/icons';
import SingleSupplierTopCard from '../../../components/TopCard/SingleSupplierTopCard';
import { PendingIconOrange } from '../../../../components/icons';
import { trackDwebEvent } from '../../../analytics';
import { Waypoint } from "react-waypoint";
import { debounce } from 'lodash';
import { defaultPageNo, defaultPageSize, defaultDebounceMs } from '../../../../paginationVariables';
import {GetPaymentStatusIconOnly,GetPaymentModes} from '../../../components/Payment/GetPaymentStatusIcon';
import SingleOnlineTransactionDetailsCard from '../../../components/Payment/SingleOnlineTransactionDetailsCard'
import TransactionDetailsSideBar from '../../../components/RightSideBar/TransactionDetailsSideBar';
import { getPaymentStatus,getSinglePayment } from '../../../../store/actions/OnlinePaymentActionCreators';
import DottedDivider from '../../../components/Divider/DottedDivider';
import TripListingCard from '../../../components/listing/TripListingCard';
const PassBookTabSupplier = ({ user, 
    dispatchFetchSupplierTransact,
    dispatchGetPaymentDetails, 
    dispatchGetSingleVendorLedger }) => {

    const [selectedFilterTransaction, setSelectedFilterTransaction] = React.useState("TRIPS_PAYMENTS");
    const [selectedFilterDate, setSelectedFilterDate] = React.useState("ALL_MONTHS");
    const [customFilter, setCustomFilter] = useState(false);
    const [customFilterValue, setCustomFilterValue] = useState({});
    const [singleVendorLedgerData, setSingleVendorLedgerData] = useState([]);
    const [passBookData, setPassBookData] = useState([]);
    const [infoOpen, setInfoOpen] = React.useState(false);
    const [supplierPdfOpen, setSupplierPdfOpen] = useState(false);
    const [searchText, setSearchText] = useState("");
    const [paymentRowData, setPaymentRowData] = useState({});
    const [paymentSideBar, setPaymentSideBar] = useState(false);
    const [deleteFlag, setDeleteFlag] = useState(false);
    const [doSearch, setDoSearch] = useState(false);
    const [doPagination, setDoPagination] = useState(false);
    const [currentPageNo, setCurrentPageNo] = useState(defaultPageNo);
    const [currentPageSize, setCurrentPageSize] = useState(defaultPageSize);
    const [loadingText, setLoadingText] = useState("No Payments are available");
    const [transactionDetailsOnlineOpen, setTransactionDetailsOnlineOpen] = useState(false);


    let location = useLocation();
    let path = location && location.pathname ? location.pathname.split("/") : [];
    let vendorIdValue = path && path[path.length - 1] ? path[path.length - 1] : "";

    const classes = PassBookTabSupplierCss();

    let history = useHistory();

    let dateFilterValues = getTripStartDateFilterValues();

    useEffect(() => {
        trackDwebEvent('Dweb Supplier Passbook Tab Selected', {
            vendor_id: vendorIdValue,
            vendor_name: user && user.singleVendorPageName ? user.singleVendorPageName : "",
            vendor_balance: user && user.singleVendorBalance ? user.singleVendorBalance : 0
        });
    }, []);

    const onSearchBlur = debounce(query => {
        setPassBookData([]);
        setLoadingText("Loading........");
        setCurrentPageNo(defaultPageNo)
        fetchPayments(false, query)
    }, user && user.configs && user.configs.dwebSearchBebounceMs ? parseInt(user.configs.dwebSearchBebounceMs) : defaultDebounceMs);

    const getPaginatedData = () => {
        fetchPayments(true)
    };

    const fetchPayments = (pagination, search) => {
        let vendorLedgerRequestData = {
            fleetOwnerId: user.userInfo.entityId,
            vendorId: vendorIdValue,
            status: TRIP_FILTER_STATUS_MAPPING["ACTIVE"],
            startDateRange: dateFilterValues["ALL_MONTHS"]["startDateRange"],
            pageNo: defaultPageNo,
            pageSize: defaultPageSize,
        }

        if (customFilterValue && customFilterValue.startTimeEpoch) {
            vendorLedgerRequestData.startDateRange = customFilterValue
        }

        var singleSupplierTransactRequestData = {
            ...{ vendorId: Number(vendorIdValue) },
            ...{ transactionType: TRIP_TRANSACTION_FILTER[selectedFilterTransaction] },
            ...{ startDateRange: dateFilterValues[selectedFilterDate]["startDateRange"] },
            pageNo: defaultPageNo,
            pageSize: defaultPageSize,
            searchText: search,
        };

        if (pagination) {
            singleSupplierTransactRequestData = {
                ...singleSupplierTransactRequestData,
                pageNo: currentPageNo + 1,
                pageSize: currentPageSize,
                searchText: search,
                merge: true
            }
        }
        if (search) {
            vendorLedgerRequestData.searchText = search && search == "null" ? "" : search;
        }
        dispatchGetSingleVendorLedger(vendorLedgerRequestData,
            (data) => {
                if (data && data.status && data.status.code == 200) {
                    logger.log("Pass Book Tab Supplier Dweb", "Single Supplier Fetch Successfull");
                    dispatchFetchSupplierTransact(singleSupplierTransactRequestData,
                        (data) => {
                            setLoadingText("No Payments are available");
                            if (data && data.status && data.status.code == 200) {
                                setDoPagination(false)
                                setDoSearch(false)
                                logger.log("Pass Book Tab Supplier Dweb", "Supplier Transaction Log Successfull");
                            }

                        },
                        () => {
                            setLoadingText("No Payments are available");
                            logger.log("Pass Book Tab Supplier Dweb", "Supplier Transaction Log Failed");
                        }
                    )
                }
            },
            () => {
                logger.log("Pass Book Tab Supplier Dweb", "Single Supplier Fetch Failed");
            }
        )
    }

    useEffect(() => {
        setPassBookData([]);
        setLoadingText("Loading........");
        setCurrentPageNo(defaultPageNo);
        fetchPayments()
    }, [selectedFilterTransaction, selectedFilterDate, customFilterValue, deleteFlag, doPagination, doSearch]);

    useEffect(() => {
        setSingleVendorLedgerData(user.singleVendorLedgerData);
        setPassBookData(user.supplierTransactionLog);
    }, [user.singleVendorLedgerData, user.supplierTransactionLog]);

    const muiData = passBookData ? passBookData : [];

    const muiColumns = [
        {
            name: "date",
            label: "Date",
            options: {
                filter: true,
                sort: false,
                customBodyRender: (value, tableMeta, updateValue) => {
                    const rowIndex = tableMeta.rowIndex;
                    if (rowIndex === muiData.length - 3) {
                        return (
                            <Fragment>
                                <Waypoint
                                    onEnter={() => {
                                        if (user && user.singleVendorPassbookMaxPage && user.singleVendorPassbookMaxPage != currentPageNo) {
                                            getPaginatedData()
                                            setCurrentPageNo(currentPageNo + 1)
                                        }
                                    }}
                                />
                                <span className={classes.fwNormal}>{value}</span>
                            </Fragment>
                        );
                    } else {
                        return <span className={classes.fwNormal}>{value}</span>
                    }
                }
            },
        },
        {
            name: "transactionName",
            label: "Trip Details",
            options: {
                filter: true,
                sort: true,
                customBodyRenderLite: (dataIndex, rowIndex) => {
                    const detailsData = muiData[dataIndex];
                    return (
                        <>
                            {detailsData && detailsData.tripDetails && detailsData.tripDetails.transactioNumber &&
                                <div className={classes.divAlignV1}>
                                    <div className={classes.fwBold}>{muiData[dataIndex] && muiData[dataIndex].transactionName ? muiData[dataIndex].transactionName : ""}</div>
                                    {detailsData.isBrokerEnabled &&
                                        <>
                                            {detailsData.paymentStatus&&
                                                <>
                                                    <GetPaymentStatusIconOnly type={detailsData.paymentStatus} />
                                                    {/* <div className={classes.divTranstNo}>{detailsData.tripDetails.transactioNumber ? detailsData.tripDetails.transactioNumber : ""}</div> */}
                                                </>
                                            }
                                        </>
                                    }
                                    {detailsData.tripDetails.trips && (detailsData.paymentStatus).toLowerCase() != "pending" &&
                                        <>
                                            <FiberManualRecordIcon className={classes.dotV1} />
                                            <div className={classes.tripInfo} >{detailsData.tripDetails.trips}</div>
                                        </>
                                    }
                                </div>
                            }
                            {detailsData && detailsData.tripDetails && !detailsData.tripDetails.transactioNumber && !detailsData.tripDetails.vehicleNumArrayDweb &&  
                                <div className={classes.divAlignV1}>
                                    <div className={classes.fwBold}>{muiData[dataIndex] && muiData[dataIndex].transactionName ? muiData[dataIndex].transactionName : ""}</div>
                                    {detailsData.isBrokerEnabled &&
                                        <>
                                            {detailsData.paymentStatus&&
                                                <>
                                                    <GetPaymentStatusIconOnly type={detailsData.paymentStatus} />
                                                    <div className={classes.divTranstNo}>{detailsData.tripDetails.transactioNumber ? detailsData.tripDetails.transactioNumber : ""}</div>
                                                </>
                                            }
                                        </>
                                    }
                                </div>
                            }
                            {detailsData && detailsData.tripDetails && detailsData.tripDetails.vehicleNumArrayDweb &&
                                <div className={classes.divAlignV1}>
                                    <div className={classes.divVehicleNumber}>
                                        {detailsData.tripDetails.vehicleNumArrayDweb.map((vehicleNumber) => (
                                            <div>
                                                {vehicleNumber}
                                            </div>
                                        ))}
                                    </div>
                                    <FiberManualRecordIcon className={classes.dotV1} />
                                    <div className={classes.fwBold}>{detailsData.transactionName ? detailsData.transactionName : ""}</div>
                                </div>
                            }
                            {/* {detailsData && detailsData.tripDetails && !detailsData.tripDetails.vehicleNumArrayDweb && !detailsData.tripDetails.trips && !detailsData.tripDetails.transactioNumber &&
                                <div className={classes.fwBold}>{muiData[dataIndex] && muiData[dataIndex].transactionName ? muiData[dataIndex].transactionName : ""}</div>
                            } */}
                        </>
                    )
                }
            },
        },
        {
            name: "amount",
            label: "Payment",
            options: {
                filter: true,
                sort: true,
                customBodyRenderLite: (dataIndex, rowIndex) => {
                    const rowData = muiData[dataIndex];
                    return (
                        <>
                            {rowData && !rowData.isExpense &&
                                <div className={classes.paymentAmount}>{rowData && rowData.amount ? numberFormat(rowData.amount) : ""}</div>
                            }
                        </>
                    )
                },
                customHeadRender: (columnMeta) => (
                    <th key={2} className={classes.thTruckRightAlign}>
                        {columnMeta.label}
                    </th>
                )
            },
        },
        {
            name: "amount",
            label: "Expense",
            options: {
                filter: true,
                sort: true,
                customBodyRenderLite: (dataIndex, rowIndex) => {
                    const rowData = muiData[dataIndex];
                    return (
                        <>
                            {rowData && rowData.isExpense &&
                                <div className={classes.divExpense}>{rowData && rowData.amount ? numberFormat(rowData.amount) : ""}</div>
                            }
                        </>
                    )
                },
                customHeadRender: (columnMeta) => (
                    <th key={3} className={classes.thTruckRightAlign}>
                        {columnMeta.label}
                    </th>
                )
            },
        }

    ];


    const options = {
        rowsPerPage: 100,
        pagination: false,
        rowsPerPageOptions: [10, 100, 250],
        filterType: "multiselect",
        fixedHeader: true,
        tableBodyHeight: tableHeightWithSparklineSingle,
        selectableRows: 'none',
        searchOpen: true,
        search: false,
        jumpToPage: false,
        download: false,
        filter: false,
        print: false,
        viewColumns: false,
        /*sortOrder: {
            name: 'sorDate',
            direction: 'desc'
        },*/
        onRowClick: (data, row) => {

            if (row) {
                let tableData = muiData[row.dataIndex];
                if (tableData) {
                    handleRowClick(tableData);
                }

            }
        },
        customToolbar: (data) => {
            return <>
                <div className={classes.divV1}>
                    <div className={classes.mtV3}>
                        <span>
                            <DateFilter dateValue={handleDateValue} fromSinglePartyPaymentTab={true} />
                        </span>
                        <span className={classes.mlV2}>
                            <PaymentTabFilter filterValue={handlePaymentFilterValue} />
                        </span>
                    </div>
                </div>
            </>
        },
        customToolbarSelect: (selectedRows, displayData, setSelectedRows) => {

        },
        searchProps: {
            variant: "outlined",
            //value: searchText,
            InputProps: {
                startAdornment: <InputAdornment position="start"><SearchIcon /></InputAdornment>,
            },
            onBlur: (e) => {
            },
            onKeyUp: (e) => {
            },
            onKeyDown: (event) => {
                if (event.keyCode === 27) {
                }
            }
        },
        searchPlaceholder: 'Search ',
        onSearchChange: (val) => {
            let value = val ? !val.replace(/\s/g, '').length ? val.trim() : val : "";
            setSearchText(value);
            if (value && value.length > 1) {
                onSearchBlur(value)
            } else if (searchText && value && value.trim().length <= 1) {
                setSearchText("");
                onSearchBlur("")
            }else{
                setSearchText("");
                onSearchBlur("")
            }
        },
        onSearchClose: () => {
        },
        customSearch: (searchQuery, currentRow, columns) => {
            let isFound = false;
            /*if (searchQuery && searchQuery.trim().length > 0) {
                searchQuery = searchQuery.trim()
                currentRow.forEach((col, index) => {
                    if (col && col.toString().toLowerCase().indexOf(searchQuery.toLowerCase()) >= 0) {
                        isFound = true;
                    }
                });
            } else {
                isFound = true;
            }*/
            return true;
        },
        textLabels: {
            body: {
                noMatch: loadingText == "No Payments are available" ? <div className={classes.noMatch}>No Payments are available</div> : "Loading........",
                toolTip: "Sort",
                columnHeaderTooltip: column => `Sort for ${column.label}`
            }
        }
    };

    const handleDateValue = (value) => {

        if (value == "CUSTOM") {
            setCustomFilter(true);
        } else {
            setSelectedFilterDate(value);
            setCustomFilter(false);
            setCustomFilterValue({});
        }

    }

    const handlePaymentFilterValue = (value) => {
        setSelectedFilterTransaction(value);
    }
    const handleOnlinePaymentDetailsClose = () => {
        setPaymentRowData(null)
        setTransactionDetailsOnlineOpen(false);
    }

    const handleRowClick = (paymentData) => {
        if (paymentData && paymentData.journeyId) {

            history.push({
                pathname: `/trips/view/${paymentData.journeyId}`,
                state: {
                    id: 7,
                    tripData: paymentData,
                    tripView: true,
                    pageTitle: 'Trip Details',
                    pageSubTitle: paymentData && paymentData.vehicleNumber ? paymentData.vehicleNumber : ''
                }
            });

        } else {
            if(paymentData){
                if(paymentData.id && paymentData.isBrokerEnabled){
                    let req ={
                        transactionId:paymentData.id,
                        entityType:'vendor',
                        entityId:vendorIdValue
                    }
                    dispatchGetPaymentDetails(
                        req,
                        (response) => {
                            if (response && response.status && response.status.code == 200 && response.response) {
                                setPaymentRowData(response.response);
                                setTransactionDetailsOnlineOpen(true);
                            }
                        },
                        (response) => {
    
                        }
                    )
                }else{
                    setPaymentRowData(paymentData);
                    setPaymentSideBar(true);
                }
            }
        }
    }

    const handlePaymentSideBarClose = () => {
        setPaymentSideBar(false);
    }

    const handlePaymentDelete = () => {
        // ************************ Reseting filter values on successfull payment delete ************************
        setDeleteFlag(!deleteFlag);
        setPaymentSideBar(false);
    }

    return (
        <>
            <TapLayout>
                <SingleSupplierTopCard />
                <div className="supplier-payment-table">
                    <MUIDataTable title={""} data={muiData} columns={muiColumns} options={options} />
                </div>
            </TapLayout>

            {paymentSideBar &&
                <PaymentDetailsSideBar invokedFrom={"passBookTabSupplier"} open={paymentSideBar} onClose={handlePaymentSideBarClose} paymentData={paymentRowData} onDelete={handlePaymentDelete} />
            }
            {transactionDetailsOnlineOpen && <TransactionDetailsSideBar
                    rightSideBarOpen={transactionDetailsOnlineOpen}
                    sideBarTitle={'Transaction Details'}
                    sideBarSecondaryTitle={null}
                    handleSubmit={event => { }}
                    toggleRightSideBar={handleOnlinePaymentDetailsClose}
                >
                    <div id="payment-details-card">
                        <SingleOnlineTransactionDetailsCard
                            data={paymentRowData}
                        />
                        {(paymentRowData && (paymentRowData.tripDetails && paymentRowData.tripDetails.length > 0 || paymentRowData.tripId)) && <><DottedDivider />
                            <TripListingCard
                                data={paymentRowData}
                                type={paymentRowData && paymentRowData.entityType ? paymentRowData.entityType : null}
                            /></>}
                    </div>
            </TransactionDetailsSideBar>}
        </>
    )
}

const mapStateToProps = (state) => (state);
const mapDispatchToProps = (dispatch) => ({
    dispatchFetchSupplierTransact: (transactData, onSuccess, onFailure) => {
        dispatch(fetchSupplierTransactionLog(transactData, onSuccess, onFailure))
    },
    dispatchGetSingleVendorLedger: (data, onSuccess, onFailure) => {
        dispatch(getSingleVendorLedgerData(data, onSuccess, onFailure))
    },
    dispatchGetPaymentDetails: (data, onSuccess, onError) => {
        dispatch(getSinglePayment(data, onSuccess, onError))
    }
});

const PassBookTabSupplierWithRouter = withRouter(PassBookTabSupplier);
export default connect(mapStateToProps, mapDispatchToProps)(PassBookTabSupplierWithRouter);
